import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const PartnersSection = () => {
  const { t } = useLanguage();
  const partners = [
    { name: "ASTEC", type: t('partners.technology'), image: `${process.env.PUBLIC_URL || ''}/partner2/astec.jpg` , scale: "normal" },
    { name: "Sun*", type: t('partners.development'), image: `${process.env.PUBLIC_URL || ''}/partner2/sun.png` , scale: "normal" },
    { name: "E-COMETRUE", type: t('partners.business'), image: `${process.env.PUBLIC_URL || ''}/partner2/ecometrue.jpg`, scale: "large" },
    { name: "HAUDI", type: t('partners.innovation'), image: `${process.env.PUBLIC_URL || ''}/partner2/haudi.jpg`, scale: "large" },
    { name: "MUMESOFT", type: t('partners.creative'), image: `${process.env.PUBLIC_URL || ''}/partner2/mume.jpg`, scale: "large"  },
    { name: "TERACOM", type: t('partners.infrastructure'), image: `${process.env.PUBLIC_URL || ''}/partner2/teracom.png`, scale: "large"  }
  ];

 return (
    <section className="py-16 bg-blue-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-normal text-center mb-12 fade-in">{t('partners.sectionTitle')}</h2>
        
        <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4 mb-12">
          {partners.map((partner, index) => (
            <div 
              key={index} 
              className="bg-white rounded-lg p-4 md:p-4 flex items-center justify-center fade-in hover:shadow-xl transition-all duration-300 hover:transform hover:-translate-y-1 h-16 md:h-20 overflow-hidden"
            >
              {/* Partner Logo */}
              <img
                src={partner.image}
                alt={partner.name}
                className={`max-w-full max-h-full object-contain ${
                  partner.scale === 'xlarge' ? 'scale-[1.8] md:scale-[2]' : 
                  partner.scale === 'large' ? 'scale-[1.3] md:scale-150' : 'scale-90'
                }`}
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                  e.currentTarget.nextElementSibling.style.display = "flex";
                }}
              />
              <div className="hidden flex-col items-center justify-center text-blue-700">
                <span className="font-bold text-sm">{partner.name}</span>
                <span className="text-gray-500 text-xs mt-1">{partner.type}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;